import React, { useEffect, useState } from 'react'
import nbrApi from '../../../services/nbrApi'
import { Link, useNavigate } from 'react-router-dom'

function OwnershipRecords() {
    const [data, setData] = useState([])
    const navigate = useNavigate()

    // fetch data 
    async function fetchList() {
        try {
            const response = await nbrApi.post('/listownershipgroups')

            const data = response.data
            setData(data)
        } catch (error) {
            console.error('Error fetching data:', error.message)
        }
    }

    // CreatePrroperty
    const handleCreatePrroperty = () => {
        navigate('/ownership-create')
    }

    // Init
    useEffect(() => {
        fetchList()
    }, [])

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Ownership Records</h4>
                        <button type='button' onClick={handleCreatePrroperty} className='btn btn-primary btn-sm'>Create New Ownership</button>
                    </div>

                    <div className="card-body">
                        {data?.length === 0 &&
                            <p className='alert alert-primary fw-bold'>No Data available !</p>}
                        {data?.length > 0 && <div className="table-responsive dataTablehistory">
                            <div className="dataTables_wrapper no-footer">
                                <table id="example" className="table shadow-hover dataTable display">
                                    <thead>
                                        <tr className='text-left'>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Status</th>
                                            <th className="text-end">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.map((item, index) => (
                                            <tr key={index} className='text-black text-capitalize'>
                                                <td>{item?.pk_id}</td>
                                                <td>{item?.group_name}</td>
                                                <td>{item?.group_description}</td>
                                                <td>{item?.status_val}</td>
                                                <td className="text-end">
                                                    <div className="d-flex justify-content-end">
                                                        <Link to={{ pathname: '/ownership-edit/' + item?.pk_id, state: item }} className="btn btn-primary shadow btn-xs sharp me-3"><i className="fas fa-pencil-alt"></i></Link>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OwnershipRecords